import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e53ee554&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=e53ee554&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e53ee554",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Customers: require('/app/components/customers/index.vue').default,Acordian: require('/app/components/acordian.vue').default})
